<template>
  <div class='table-box'>
    <global-tag>
      <el-form
        :inline='true'
        :model='searchlist'
        class='demo-form-inline'
        size='mini'
      >
        <el-form-item label='职位名称:'>
          <el-input
            v-model='searchlist.postName'
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type='primary'
            icon='el-icon-search'
            @click='searchlistdata'
          >查询
          </el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type='info'
            @click='searchlistReset'
          >重置
          </el-button
          >
        </el-form-item>
        <el-form-item></el-form-item>
      </el-form>
    </global-tag>
    <div class='three'>
      <el-button
        type='primary'
        size='mini'
        @click="showDialog('新增')"
      >新增职位
      </el-button
      >
    </div>
    <!-- 表格盒子 -->
    <div class='table_card'>
      <el-table
        :data='tableData'
        :header-cell-style="{ background: '#f8fafa' }"
        border
        highlight-current-row
      >
        <el-table-column
          align='center'
          prop='postName'
          label='职位名称'
        ></el-table-column>
        <el-table-column
          align='center'
          prop='postSort'
          label='排序'
        ></el-table-column>
        <el-table-column
          align='center'
          label='操作'
          fixed='right'
        >
          <template slot-scope='scope'>
            <el-tooltip
              class='item'
              effect='light'
              content='查看'
              placement='top-start'
            >
              <button
                class='
                                                    iconfont
                                                    icon-chakan
                                                    tabBtn tabBtn-detail
                                                '
                @click="
                                                    showDialog(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='light'
              content='修改'
              placement='top-start'
            >
              <button
                class='
                                                    iconfont
                                                    icon-bianji3
                                                    tabBtn tabBtn-edit
                                                '
                @click="
                                                    showDialog(
                                                        '修改',
                                                        scope.row
                                                    )
                                                "
              ></button>
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='light'
              content='删除'
              placement='top-start'
            >
              <button
                class='
                                                    iconfont
                                                    icon-icon7
                                                    tabBtn tabBtn-delete
                                                '
                @click='
                                                    deleteItem(scope.row.id)
                                                '
              ></button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
        :page-size='pageConfig.pageSize'
        layout='total, prev, pager, next, jumper'
        @current-change='handleCurrentChange'
        :total='pageConfig.total'
      ></el-pagination>
    </div>

    <!-- 弹出框修改 -->
    <el-dialog
      :title='dialogTitle'
      :visible.sync='showDialogVisible'
      width='600px'
      :before-close='dialogClose'
    >
      <el-form
        ref='dialogfrom'
        :rules='rules'
        :model='addForm'
        label-width='100px'
        size='mini'
      >
        <el-form-item label='职位名称:' prop='postName'>
          <el-input
            v-model='addForm.postName'
            :disabled="dialogTitle === '查看'"
            placeholder='请输入'
          ></el-input>
        </el-form-item>
        <el-form-item label='排序:' prop='postSort'>
          <el-input
            type='number'
            v-model='addForm.postSort'
            :disabled="dialogTitle === '查看'"
            placeholder='请输入'
          ></el-input>
        </el-form-item>
      </el-form>
      <div class='boontbtn'>
        <el-button
          v-if="dialogTitle !== '查看'"
          type='primary'
          size='small'
          style='margin: 0 30px'
          @click='send'
        >
          确定
        </el-button>
        <el-button type='info' size='small' @click='dialogClose'
        >关闭
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/system.css'
import { post } from '@/api/requrestHttp'

export default {
  data() {
    return {
      addForm: {},
      dialogTitle: '新增',
      showDialogVisible: false,
      rules: {
        postName: [
          {
            required: true,
            message: '请输入职位名',
            trigger: 'blur'
          }
        ],
        postSort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }
    }
  },
  methods: {
    deleteItem(id) {
      this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await post('/rbac/admin/post/delete', { id: id })
          if (res.code == 200) {
            this.getTableData()
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    async send() {
      let url
      if (this.dialogTitle === '新增') {
        url = '/rbac/admin/post/save'
      } else {
        url = '/rbac/admin/post/update'
      }
      const res = await post(url, this.addForm)
      this.getTableData()
      this.dialogClose()
      console.log(res)
    },
    dialogClose() {
      this.showDialogVisible = false
      this.addForm = {}
      this.$refs.dialogfrom.resetFields()
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getTableData()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getTableData()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    //获取列表数据
    async getTableData() {
      const { content } = await post('/rbac/admin/post/list', {
        ...this.searchlist,
        ...this.pageConfig
      })
      this.tableData = content.list || []
      this.pageConfig.total = content.count
    },
    async showDialog(type, row) {
      this.showDialogVisible = true
      this.dialogTitle = type
      if (row) {
        this.addForm = row
      }
    }
  },
  mounted() {
    this.getTableData()
  }
}
</script>

